export const DATA_CREDITS_HIGH_USAGE_USED_RATIO_THRESHOLD = 0.9;
export const DEFAULT_CONTACT_COST = 1;
export const AI_AGENT_PRICE_PER_RECORD = 10;
export const AI_AGENT_MAX_OPTION_VALUE = 1;
